<script>
import Switch from './Switch.svelte'
export let toggleTheme

  
</script>

<Switch action={toggleTheme} />